import(/* webpackMode: "eager" */ "/home/SILANGIT-FIX/fe-silangit-app-fix/node_modules/next/dist/client/link.js");
